// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"37699a3b","453":"938dc06e","597":"8da9e7ed","857":"a51d9958","940":"c71d290c","998":"5eb84ef9"}[chunkId] + ".chunk.js";
};